module.exports = __webpack_public_path__ + "img/register-company-online.eb68445a.png";